// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xMPT","controls":"styles_controls__3__Pq","charLimit":"styles_charLimit__2lfqi","input":"styles_input__1CDLm","send":"styles_send__3hK0I"};